import styles from './InnerHeader.module.css'
import React, { useMemo, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { FormBuilderContext } from '../../../store/store.FormBuilder'

const InnerHeader = observer(() => {
  const storeFormBuilder = useContext(FormBuilderContext)
  return <div className={styles.innerHeader}></div>
})

export default InnerHeader
